module.exports = __webpack_public_path__ + "img/HZ-T1548.842510cd.jpg";